<template>
  <div class="nav" :style="{ background: background}">
    <div class="nav-content">
      <div class="left" @click="onClickLeft">
        <slot name="left">
          <van-icon name="arrow-left" style="vertical-align: middle;"/>
        </slot>
      </div>
      <div class="title">
        <slot name="title">
          <h3 :style="{color:titleColor}">{{title}}</h3>
        </slot>
      </div>
      <div class="right">
        <slot name="right">
          <div class="right-text" :style="{color:rightTextColor}" @click="onClickRight">
            {{rightText}}
          </div>
        </slot>
      </div>
    </div>
  </div>
</template>

<script>
  import {
    reactive
  } from 'vue'
  // import {
  //   useRouter
  // } from 'vue-router'

  export default {
    name:'myNav',
    props: {
      title: {
        type: String,
        default: "",
      },
      rightText: {
        type: String,
        default: "",
      },
      titleColor:{
        type: String,
        default: "#333",
      },
      rightTextColor:{
        type: String,
        default: "#12CDB0",
      },
      backImage:{
        type: String,
        default: "",
      },
      background:{
        type: String,
        default: "#fff",
      }
    },
    setup(props,{ emit }) {
      // const router = useRouter()
      const state = reactive({

      })
      const onClickRight=()=>{
        emit('click-right')
      }
      const onClickLeft=()=>{
        emit('click-left')
      }
      return {
        state,
        onClickRight,
        onClickLeft
      }
    }
  }
</script>

<style scoped="scoped">
  .nav{
    padding-top: constant(safe-area-inset-top);
    padding-top: env(safe-area-inset-top);
    background-size: cover;
    background-position: center bottom;
    
  }
  .nav .nav-content{
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 16px;
    position: relative;
    height: 48px;
  }
  .nav .nav-content .left{
    font-size: 16px;
    width: 24px;
    height: 24px;
    line-height: 24px;
    text-align: center;
  }
  .nav .nav-content .left img{
    width: 21px;
    height: 21px;
    vertical-align: middle;
  }
  .nav .nav-content .title{
    font-size: 14px;
    width: 100%;
    flex: 1;
    padding: 0 10px;
  }
  .nav .nav-content .right{
    font-size: 15px;
  }
</style>